import { useEffect } from "react";
import { Redirect, Route, Switch, HashRouter } from "react-router-dom";
import DicioBackConnectionIneAPIDoc from "./pages/DicioBackConnectionIneAPIDoc";
import DicioBackFintechPagosMiddlewareAPIDoc from "./pages/DicioBackFintechPagosMiddlewareAPIDoc";
import DicioBackRenapoAPIDoc from "./pages/DicioBackRenapoAPIDoc";
import DicioBackTokenAPIDoc from "./pages/DicioBackTokenAPIDoc";
import CommonFaceModelsAPIDoc from "./pages/CommonFaceModelsAPIDoc";
import KycSdkStorageAPIDoc from "./pages/KycSdkStorageAPIDoc";
import Home from "./pages/home";
import { AuthProvider } from "./auth/AuthContext";
import LoginGate from "./components/LoginGate";
import { documentTitle } from "./config/appConfig";
import { I18nProvider } from "./i18n/I18nContext";

const App = () => {
    useEffect(() => {
        document.title = documentTitle;
    }, []);

    return (
        <I18nProvider>
            <AuthProvider>
                <LoginGate>
                    <HashRouter>
                        <Switch>
                            <Route exact path="/">
                                <Home />
                            </Route>
                            <Route exact path="/nom151">
                                <DicioBackFintechPagosMiddlewareAPIDoc />
                            </Route>
                            <Route exact path="/renapo">
                                <DicioBackRenapoAPIDoc />
                            </Route>
                            <Route exact path="/lista-nominal">
                                <DicioBackConnectionIneAPIDoc />
                            </Route>
                            <Route exact path="/common-face-models-api">
                                <CommonFaceModelsAPIDoc />
                            </Route>
                            <Route exact path="/kyc-sdk-storage">
                                <KycSdkStorageAPIDoc />
                            </Route>
                            <Route exact path="/token">
                                <DicioBackTokenAPIDoc />
                            </Route>
                            <Redirect to="/" />
                        </Switch>
                    </HashRouter>
                </LoginGate>
            </AuthProvider>
        </I18nProvider>
    );
};

export default App;
